import { render, staticRenderFns } from "./AdvancedConfig.vue?vue&type=template&id=83b00b9c&"
import script from "./AdvancedConfig.vue?vue&type=script&lang=js&"
export * from "./AdvancedConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports